var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper" },
    [
      _c("div", { staticClass: "filter-container v-application" }, [
        _c("h4", [_vm._v("Filter ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "v-application ml-10" },
          [
            _c(
              "v-text-field",
              {
                attrs: {
                  placeholder: "Titel",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                  clearable: "",
                },
                on: {
                  "click:clear": function ($event) {
                    _vm.filter.title = ""
                  },
                },
                model: {
                  value: _vm.filter.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "title", $$v)
                  },
                  expression: "filter.title",
                },
              },
              [
                _c(
                  "template",
                  { slot: "prepend-inner" },
                  [
                    _vm.filter.filter_type === "contains"
                      ? _c(
                          "v-icon",
                          {
                            attrs: { color: "info" },
                            on: { click: _vm.onFilterChanged },
                          },
                          [_vm._v("mdi-equal")]
                        )
                      : _c(
                          "v-icon",
                          {
                            attrs: { color: "info" },
                            on: { click: _vm.onFilterChanged },
                          },
                          [_vm._v("mdi-not-equal")]
                        ),
                  ],
                  1
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("v-select", {
              staticClass: "ml-2",
              attrs: {
                placeholder: "Zustand",
                items: _vm.statusOptions,
                "hide-details": "",
                outlined: "",
                dense: "",
                clearable: "",
              },
              model: {
                value: _vm.filter.wf_state,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "wf_state", $$v)
                },
                expression: "filter.wf_state",
              },
            }),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "ml-5 mt-1",
                attrs: { small: "", rounded: "", disabled: !_vm.isFiltered },
                on: { click: _vm.clearFilter },
              },
              [
                _c("v-icon", { staticClass: "ml-1", attrs: { small: "" } }, [
                  _vm._v("mdi-cancel"),
                ]),
                _vm._v("\n                Filter zurücksetzen\n            "),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "v-application", attrs: { disabled: _vm.isLoading } },
        [
          _c(
            "v-card-text",
            { staticClass: "pb-0" },
            [
              _c("v-data-table", {
                staticClass: "v-application--is-ltr",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.ticketsList,
                  "items-per-page": 10,
                  page: _vm.pageNumber,
                  options: _vm.tableOptions,
                  "server-items-length": _vm.ticketsCount,
                  "item-key": "_id",
                  loading: _vm.isLoading,
                  expanded: _vm.expanded,
                  "no-data-text": "Keine Suchergebnisse",
                  "loading-text": "Wird geladen...",
                  "disable-sort": "",
                  "footer-props": {
                    "items-per-page-options": [5, 10, 25, 50],
                    "show-first-last-page": true,
                    "show-current-page": true,
                    "items-per-page-text": "Zeilen pro Seite",
                  },
                },
                on: {
                  "update:page": function ($event) {
                    _vm.pageNumber = $event
                  },
                  "update:options": [
                    function ($event) {
                      _vm.tableOptions = $event
                    },
                    _vm.onOptionsChange,
                  ],
                  "update:expanded": function ($event) {
                    _vm.expanded = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function ({ item, expand, isExpanded }) {
                      return [
                        _c("tr", { attrs: { "data-id": item?._id } }, [
                          _c("td", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item?._id) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.workflow_states[item.wf_state]) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: `/pharmacies/${item?.ref_pharmacy?._id}`,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item?.ref_pharmacy?.name || "") +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: `/pharmacists/${item?.ref_pharmacist?._id}`,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        item?.ref_pharmacist?.firstname || ""
                                      ) +
                                      " " +
                                      _vm._s(
                                        item?.ref_pharmacist?.lastname || ""
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.ticketAppointmentHref(item)
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.ticketAppointmentHref(item),
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.formatAppointmentDate(
                                              item?.ref_appointment?.date
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.formatAppointmentDate(
                                            item?.ref_appointment?.date
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-5" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item.title) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "col-md-1" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return expand(!isExpanded)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      _vm._s(
                                        isExpanded
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-1" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.categories[item.category]) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-3" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getMomentDate(item.created)) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-2" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `/pharmacists/${item?.creator?._id}`,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item?.creator?.firstname) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-2" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item?.resubmit) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-md-2" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `/crm/${item?._id}/edit`,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("v-icon", { attrs: { color: "primary" } }, [
                                  _vm._v(
                                    "\n                                    mdi-pencil\n                                "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "expanded-item",
                    fn: function ({ item }) {
                      return [
                        _c("tr", { attrs: { "data-id": item?._id } }, [
                          _c("td", { attrs: { colspan: "3" } }),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c("div", { staticClass: "px-4 py-4" }, [
                              _c("strong", [_vm._v("Beschreibung:")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description" }, [
                                _vm._v(_vm._s(item.description)),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "1" } }),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }